import React from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { DateInput, ImagePreview, SelectInput, StyledDropzoneArea, UploadButtonZone } from './style';

const AddContracts = ({ formData, setFormData }) => {
  const imgToBase64 = (file, field) => {
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        setFormData({
          ...formData,
          [field]: e.target.result,
        });
        return;
      };
    }
    return;
  };

  return (
    <>
      <TextField
        label="Nome do Cliente"
        fullWidth
        value={formData?.name || ''}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        margin="normal"
        variant="outlined"
      />
      <StyledDropzoneArea>
        <Grid container spacing={2}>
          <UploadButtonZone item xs={4}>
            <ImagePreview src={formData?.firstImage?.Location ?? formData?.firstImage} />
            <input onChange={(e) => imgToBase64(e.target.files[0], 'firstImage')} style={{ display: 'none' }} id="firstImage" accept="image/*" type="file" />
            <label htmlFor="firstImage">
              <Button variant="contained" color="primary" component="span">
                Upload
              </Button>
            </label>
          </UploadButtonZone>
          <UploadButtonZone item xs={4}>
            <ImagePreview src={formData?.secondImage?.Location ?? formData?.secondImage} />
            <input onChange={(e) => imgToBase64(e.target.files[0], 'secondImage')} style={{ display: 'none' }} id="secondImage" accept="image/*" type="file" />
            <label htmlFor="secondImage">
              <Button variant="contained" color="primary" component="span">
                Upload
              </Button>
            </label>
          </UploadButtonZone>
          <UploadButtonZone item xs={4}>
            <ImagePreview src={formData?.thirdImage?.Location ?? formData?.thirdImage} />
            <input onChange={(e) => imgToBase64(e.target.files[0], 'thirdImage')} style={{ display: 'none' }} id="thirdImage" accept="image/*" type="file" />
            <label htmlFor="thirdImage">
              <Button variant="contained" color="primary" component="span">
                Upload
              </Button>
            </label>
          </UploadButtonZone>
        </Grid>
      </StyledDropzoneArea>
      <DateInput
        id="date"
        label="Data de Início"
        type="date"
        onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
        defaultValue={formData?.startDate}
        InputLabelProps={{
          shrink: true,
        }}
        margin="normal"
        variant="outlined"
      />
      <SelectInput
        native
        variant="outlined"
        value={formData?.business || ''}
        onChange={(e) => setFormData({ ...formData, business: e.target.value })}
        inputProps={{
          name: 'Négocio?',
        }}
      >
        <option aria-label="None" value="">
          Négocio?
        </option>
        <option value="Facilities">Facilities</option>
        <option value="Industrial">Industrial</option>
        <option value="Logística">Logística</option>
      </SelectInput>
      <TextField
        label="Localização(Google maps link)"
        fullWidth
        value={formData?.locale || ''}
        onChange={(e) => setFormData({ ...formData, locale: e.target.value })}
        margin="normal"
        variant="outlined"
      />
    </>
  );
};

export default AddContracts;
